// ui/Tabs — underline tabs (Design Standard v1); the row scrolls on phone and the
// active tab scrolls itself into view. Accent appears only as the 2px underline.
import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import './ds.css';

export const Tabs = ({ children, className = '' }) => <div className={clsx('w-full', className)}>{children}</div>;

export const TabsList = ({ children, className = '', ...rest }) => (
  <div role="tablist" className={clsx('ds-tabs', className)} {...rest}>{children}</div>
);

export const TabsTrigger = ({ value, current, onClick, children, className = '' }) => {
  const active = value === current;
  const ref = useRef(null);
  useEffect(() => {
    if (active) ref.current?.scrollIntoView?.({ inline: 'nearest', block: 'nearest' });
  }, [active]);
  return (
    <button ref={ref} type="button" role="tab" aria-selected={active}
      onClick={() => onClick?.(value)} className={clsx('ds-tab', active && 'is-active', className)}>
      {children}
    </button>
  );
};

export const TabsContent = ({ value, current, children, className = '' }) =>
  value === current ? <div role="tabpanel" className={clsx('pt-3', className)}>{children}</div> : null;

/** Data form: <TabBar tabs={[{id,label}]} value={id} onChange={setId} /> */
export function TabBar({ tabs = [], value, onChange, className = '' }) {
  return (
    <TabsList className={className}>
      {tabs.map((t) => (
        <TabsTrigger key={t.id} value={t.id} current={value} onClick={onChange}>{t.label}</TabsTrigger>
      ))}
    </TabsList>
  );
}
